import React, { useEffect, useState } from 'react';
import CryptoJS from "crypto-js";
import { secretKey } from "../../env.json";

const ModalCaptcha = ({ onDismissModal, onBookSelect, bookDetails }) => {
  const [errorMessage, setErrorMessage] = useState(''); // To store the error message
  const [captchaValid, setCaptchaValid] = useState(false); // To track captcha validity
  const [captchaInput, setCaptchaInput] = useState('');
  const [captchaStartTime, setCaptchaStartTime] = useState(Date.now());
  const [captchaLength, setCaptchaLength] = useState(6);
  useEffect(() => {
    // Initialize Bootstrap modal using jQuery
    $('#modalCaptcha').modal({
      backdrop: 'static',
      keyboard: false,
    });

    // Show captcha when the modal is fully visible
    $('#modalCaptcha').on('shown.bs.modal', function () {
      getCaptcha('canvas'); // Generate captcha when modal opens
    });

    // Handle modal close event
    $('#modalCaptcha').on('hidden.bs.modal', function () {
      if (!captchaValid) {
        $('#modalCaptcha').modal('show'); // Keep the modal open if captcha is not valid
      } else {
        // Remove backdrop and call dismiss callback
        $('.modal-backdrop').remove(); // Remove the backdrop element
        onDismissModal(false); // Callback for modal close if captcha is valid
      }
    });

    // Cleanup function to remove event listeners
    return () => {
      $('#modalCaptcha').modal('hide');
      $('#modalCaptcha').off('shown.bs.modal'); // Remove the shown event listener
      $('#modalCaptcha').off('hidden.bs.modal'); // Remove the hidden event listener
    };
  }, [captchaValid]);

  const encryptData = (data) => {
    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
    return ciphertext;
  };

  const decryptData = (ciphertext) => {
  const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
  const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  return decryptedData;
}

// Function to generate a random code
const generateCode = () => {
  // const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ2345689'; // Exclude I, O, 0, 1, 7
  const chars = '012345689'; // Exclude I, O, 0, 1, 7
  let result = '';
  for (let i = 0; i < captchaLength; i++) {
    const randomIndex = Math.floor(Math.random() * chars.length);
    result += chars[randomIndex];
  }
  return result;
};

const getCaptcha = (id) => {
  const canvas = document.getElementById(id);
  const pen = canvas.getContext("2d");
  const width = canvas.width, height = canvas.height;

  // Generate 4-digit numeric CAPTCHA
  // const plainCaptcha = Math.floor(1000 + Math.random() * 9000).toString();
  const plainCaptcha = generateCode();

  // Encrypt and store in sessionStorage
  const encryptedCaptcha = encryptData(plainCaptcha);
  sessionStorage.setItem("captcha", encryptedCaptcha);

  // Draw CAPTCHA visually (only using plain text)
  pen.fillStyle = "#D3D3D3"; // Light gray background
  pen.fillRect(0, 0, width, height);

  // Draw multiple background lines
  for (let i = 0; i < 8; i++) {
    pen.beginPath();
    pen.setLineDash(i % 2 === 0 ? [5, 7] : []);
    pen.moveTo(Math.random() * width, Math.random() * height);
    pen.bezierCurveTo(
      Math.random() * width, Math.random() * height,
      Math.random() * width, Math.random() * height,
      Math.random() * width, Math.random() * height
    );
    pen.strokeStyle = `rgba(50, 50, 50, ${Math.random() * 0.5 + 0.2})`;
    pen.lineWidth = Math.random() * 2 + 1;
    pen.stroke();
  }

  // Draw digits with wave pattern
  let x = 20;
  const amplitude = 10, frequency = 2;
  for (let i = 0; i < plainCaptcha.length; i++) {
    pen.font = `${Math.floor(Math.random() * 10 + 40)}px Arial bold`;
    pen.fillStyle = "#4D4D4D";
    pen.save();
    const yOffset = Math.sin(i * frequency) * amplitude;
    pen.translate(x, 50 + yOffset);
    pen.rotate((Math.random() - 0.5) * 0.2);
    pen.fillText(plainCaptcha[i], 0, 0);
    pen.restore();
    x += 35;
  }

  setCaptchaInput('');
  setCaptchaStartTime(Date.now());
  setErrorMessage('');
};

function botDetection(){
  setCaptchaInput("")
  alert("You can no longer interact with this bot.")
}

const handleCaptchaInput = (e) => {
  const input = e.target.value.toUpperCase(); // Make case-insensitive
  const now = Date.now();

  // Block more characters than expected
  if (input.length > captchaLength) {
    setErrorMessage('Input exceeds captcha length.');
    return;
  }

  // Block typing too fast (like a bot)
  const timeTaken = now - captchaStartTime;
  if (input.length >= 4 && timeTaken < 400) {
    // Less than 100ms per keystroke
    botDetection();
    return;
  }

  setCaptchaInput(input);

  // Only validate if full input entered
  if (input.length === captchaLength) {
    validateCaptchaInput(input);
  } else {
    setErrorMessage('');
  }
};

const validateCaptchaInput = (enteredCaptcha) => {
  let storedCaptcha = sessionStorage.getItem('captcha');
  if (!storedCaptcha) {
    setErrorMessage("Captcha session expired. Please refresh.");
    return;
  }

  try {
    storedCaptcha = decryptData(storedCaptcha);
  } catch (error) {
    setErrorMessage("Error decoding captcha.");
    return;
  }

  if (enteredCaptcha === storedCaptcha) {
    $('#modalCaptcha').modal('hide');
    setErrorMessage('');
    setCaptchaValid(true);
    setTimeout(() => {
      onBookSelect(bookDetails, true);
    }, 350);
  } else {
    setErrorMessage('Invalid captcha. Please try again.');
  }
};




  return (
    <div className="modal fade modal-responsive" id="modalCaptcha" tabIndex="-1" role="dialog">
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            {/* No close button to prevent closing */}
          </div>
          <div className="modal-body text-center">
            <div id="ModalCaptchaHolder">
              <div id="messageCaptchaModel"></div>
              <canvas width="240" height="65" style={{ border: '1px solid #dddddd' }} id="canvas"></canvas>
              <button
                type="button"
                onClick={() => getCaptcha('canvas')}
                className="btn btn-success margin-l15 margin-b55"
                style={{ borderRadius: '100%', fontSize: '18px' }}
              >
                <i className="fa fa-refresh"></i>
              </button>
              <div id="captchaForm" role="form">
                <input type="text" id="txtCaptcha" style={{display: 'none'}}  onChange={botDetection}/>
                <div className="form-group">
                  <input
                    id="txtCaptcha"
                    name="txtCode"
                    type="text"
                    className="form-control"
                    placeholder="Enter Captcha"
                    value={captchaInput}
                    onChange={(e) => handleCaptchaInput(e)}
                    onPaste={(e) => e.preventDefault()}
                    onDrop={(e) => e.preventDefault()}
                    onContextMenu={(e) => e.preventDefault()}
                    autoComplete="off"
                  />
                </div>
                {/* Display error message if captcha is invalid */}
                {errorMessage && <div className="text-danger">{errorMessage}</div>}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            {/* No submit button needed */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalCaptcha;
